import { useQuery } from '@tanstack/react-query';
import getRulesets from 'Api/schedule-generate/getRulesets';
import getRulesetsRequest from './model/request/getRulesetsRequest';
import getRulesetsResponse from './model/response/getRulesetsResponse';

const useGetRulesets = (queryParams) => {
  const { yearMonth, brand } = queryParams;
  return useQuery({
    queryKey: ['rulesets', queryParams],
    queryFn: async () => {
      const queries = getRulesetsRequest(queryParams);

      const response = await getRulesets(queries);

      const result = getRulesetsResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: !!yearMonth && !!brand,
  });
};

export default useGetRulesets;
